export default {
  en: {
    register: 'Register',
    alreadyHaveAccount: 'Already have an account? Log in',
    confirm: 'Confirm',
    firstName: 'First Name',
    firstNameError: 'First name cannot be blank',
    lastName: 'Last Name',
    lastNameError: 'Last name cannot be blank',
    email: 'Email',
    emailBlankError: 'Email cannot be blank',
    emailValidError: 'Email must be valid',
    password: 'Password',
    passwordRequiredError: 'Password is required',
    passwordShortError: 'Password must be at least 8 characters long',
    confirmPassword: 'Confirm Password',
    confirmPasswordRequiredError: 'Confirm password is required',
    confirmPasswordMatchError: 'Passwords do not match',
    requiredField: 'Please fill in all required fields',
  },
  tr: {
    register: 'Kayıt ol',
    alreadyHaveAccount: 'Zaten hesabınız var mı? Oturum aç',
    confirm: 'Onaylamak',
    firstName: 'İsim',
    firstNameError: 'Ad boş bırakılamaz',
    lastName: 'Soyadı',
    lastNameError: 'Soyadı boş bırakılamaz',
    email: 'E-posta',
    emailBlankError: 'E-posta boş bırakılamaz',
    emailValidError: 'E-posta geçerli olmalı',
    password: 'Parola',
    passwordRequiredError: 'Şifre gereklidir',
    passwordShortError: 'Şifre en az 8 karakter uzunluğunda olmalı',
    confirmPassword: 'Şifreyi Onayla',
    confirmPasswordRequiredError: 'Parolayı onaylamak gerekiyor',
    confirmPasswordMatchError: 'Parolalar uyuşmuyor',
    requiredField: 'Lütfen gerekli tüm alanları doldurun',
  },
};
